<template>
    <v-btn id="add-match-button"
           :disabled="isDisabled"
           name="add-match-button"
           ref="add-match-button"
           @click="onClick"
    >
        <v-icon class="material-icons">flip</v-icon>
        <tippy
            v-if="showAddMatchTooltip"
            theme="--start"
            :visible="true"
            trigger="manual"
            to="add-match-button"
            :onHide="() => { this.$store.dispatch('UI/setAddMatchTooltip', false) }"
            :duration="[250, 0]"
            placement="bottom"
        >
            {{ showAddMatchTooltip }}
        </tippy>
        <tippy
            v-else
            theme=""
            :visible="false"
            to="add-match-button"
            trigger="mouseenter focus"
            :duration="[250, 250]"
            placement="bottom"
        >
            Save look as a Match
        </tippy>
    </v-btn>

</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    mounted() {
        this.$root.$refs.addMatchButton = this.$refs['add-match-button'];
    },
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        isDisabled() {
            return !this.canCreateAssets || !this.image || this.IDT.initial || this.blockLoading
        }
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;

            window.UI.showModal(window.UI.modals.newMatch.el);
        }
    }
}
</script>